module.exports = __webpack_public_path__ + "09a519612ea6ddc79361340a6dd4fd36.png";